import { errorToast } from "./DPToast";

export const downloadS3File = (url: string) => {
  const errorMessage = "Download failed. Please try again. For troubleshooting assistance please contact Partner Support at partner.support@dailypay.com";

  try {
    // create temporary anchor tag to download file from url returned by mutation
    const a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", "");
    document.body.appendChild(a);
    a.click();
    // cleanup
    a.parentNode && a.parentNode.removeChild(a);
  } catch {
    errorToast(errorMessage);
  }
};
